"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellCollection = void 0;
var tslib_1 = require("tslib");
var table_cell_1 = require("../../table/table-cell");
var collection_1 = require("../collection");
var TableCellCollection = (function (_super) {
    tslib_1.__extends(TableCellCollection, _super);
    function TableCellCollection(processor, tablePosition) {
        var _this = _super.call(this, processor) || this;
        _this._tablePosition = tablePosition;
        return _this;
    }
    TableCellCollection.prototype._getItem = function (coreItem) {
        var pos = this._tablePosition.clone();
        pos.cellIndex = pos.row.cells.indexOf(coreItem);
        pos.cell = pos.row.cells[pos.cellIndex];
        return new table_cell_1.TableCellApi(pos);
    };
    TableCellCollection.prototype._getCoreItems = function () {
        return this._tablePosition.row.cells;
    };
    return TableCellCollection;
}(collection_1.Collection));
exports.TableCellCollection = TableCellCollection;
